module.exports = __webpack_public_path__ + "img/17.fae7474b.jpg";